import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/norm.css';

function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50); // Delay before animation starts
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Section 1: Mission & Vision */}
            <div className="container-fluid about-bg7 d-flex align-items-end mb-5" style={{ padding: 0, minHeight: '60vh',top: '-122px'}}>
                <div className="container-fluid align-items-center justify-content-center about-content">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="d-flex flex-column flex-md-row align-items-start ms-5">
                                <div className="me-md-5">
                                    <h1 className="about-title">NORM Services</h1>
                                    <h2 className="about-subtitle">Naturally Occurring Radioactive Materials</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                </div>
                                <div>
                                    {/* <p className="about-desc ms-5 align-items-center" style={{ fontSize: 19 }}>
                                        At Petrochoice, we provide a comprehensive team of specialized drilling personnel and performance specialists, including rig crew members, who are crucial to optimizing drilling operations, minimizing lost time, and reducing costs. Our diverse team comprises experts in various drilling aspects, ensuring that we offer comprehensive support and expertise throughout the drilling process.
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 2: Info */}

            <div className="container d-flex align-items-center justify-content-start mb-5 hse-section" style={{ padding: 0, minHeight: '100vh' }}>
                <div className="row w-100">
                    <div className="col-lg-5 col-md-12">
                        <h2 className="hse-title">NORM Services</h2>
                        <p className="hse-text mb-5" style={{ fontSize: '1.2rem' }}>
                            Our cadre of seasoned professionals boasts unparalleled expertise, harnessing an intricate blend of industry acumen, cutting-edge technology, and a stellar track record to effectively tackle the multifaceted challenges posed by NORM. From fastidious surveys and vigilant radiation monitoring to adept NORM management, meticulous decontamination processes, and the responsible disposal of waste, we encompass the entire spectrum to fortify your operations while minimizing the environmental footprint.
                        </p>
                        <p className="hse-text" style={{ fontSize: '1.2rem' }}>
                            At PETROCHOICE Integrated Services, our unwavering commitment revolves around prioritizing stringent regulatory compliance, ensuring that your operations not only meet but surpass industry benchmarks. We invite you to explore our all-encompassing NORM solutions, meticulously designed to harmonize the dual imperatives of safety and environmental responsibility, all while optimizing operational efficiency.
                        </p>
                    </div>
                    <div className='col-lg-1'></div>
                    <div className="col-lg-6 col-md-12">
                        <div className="hse-image">
                            <img src="/assets/norm.png" alt="HSE Operations" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
